import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
// import { GoogleMap, LoadScript, Marker, StandaloneSearchBox } from '@react-google-maps/api';
import {
  GoogleMap,
  useLoadScript,
  LoadScript,
  Marker,
  Autocomplete,
  StandaloneSearchBox,
} from "@react-google-maps/api";

import { getApiBaseUrl } from "../../utils/utils";
import "../../modalright.css";
import "../../popup.css";
import axios from "axios";
import jQuery from "jquery";
import { useLocation } from "react-router-dom";
import { CSVLink } from "react-csv";
export default function AddressCorrection() {
  // Dummy data for drivers and locations
  const API_URL = process.env.REACT_APP_API_URL;
  const [activeTab, setActiveTab] = useState("ALL");
  const location = useLocation();
  const $ = jQuery.noConflict();
  const [orders, setOrders] = useState([]); // Store API response (orders)
  const [allOrders, setallOrders] = useState([]); // Store API response (orders)
  const [loading, setLoading] = useState(true); // For showing loading state
  const [error, setError] = useState(null); // For showing error messages

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [selectedRows, setSelectedRows] = useState([]);
  console.log("selectedRows", selectedRows);

  const autocompleteRef = useRef(null);

  useEffect(() => {
    $(".btn-demo.import").on("click", function () {
      $(".nalier.middle-center.fade").css("display", "block");
      $(".nalier.middle-center.fade").addClass("in");
    });

    $(".close.h-close").on("click", function () {
      $(".nalier.middle-center.fade.in").css("display", "none");
      $(".nalier.middle-center.fade").removeClass("in");

      $(".nalier.middle-center2.fade.in").css("display", "none");
      $(".nalier.middle-center2.fade").removeClass("in");

      $(".nalier.middle-center3.fade.in").css("display", "none");
      $(".nalier.middle-center3.fade").removeClass("in");

      $(".nalier.right.fadeNalier.in").css("display", "none");
      $(".nalier.right.fadeNalier").removeClass("in");
    });
  }, []);
  const columns = [
    {
      name: "Job ID",
      selector: (row) => row.jobId, // Use 'selector' instead of 'accessor'
      sortable: true,
    },
    {
      name: "Formatted Address",
      selector: (row) => row.formattedAddress,
      sortable: true,
    },
    {
      name: "Note",
      selector: (row) => row.note,
    },
    {
      name: "Created Date",
      selector: (row) => new Date(row.createdDate).toLocaleString(),
      sortable: true,
    },
    {
      name: "Modified Date",
      selector: (row) => new Date(row.modifiedDate).toLocaleString(),
      sortable: true,
    },
    {
      name: "Valid",
      selector: (row) => (row.valid ? "Yes" : "No"),
    },
    {
      name: "Action",
      button: true,
      cell: (row) => (
        <button onClick={() => handleViewReassign(row.jobId, row.id)}>
          View{" "}
        </button>
      ),
    },
  ];

  const tableData = {
    columns,
    data: orders,
    export: true, // if you want export functionality, set it to true
    filterPlaceholder: "Search...", // placeholder text for search input
  };

  const libraries = ["places"];
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyDLZVOcpauxwwsb3J9m1GcwOqAO9aikUEk",
    libraries,
  });

  const intervalRef = useRef(null);
  const activeTabRef = useRef(activeTab);

  useEffect(() => {
    activeTabRef.current = activeTab;
  }, [activeTab]);

  useEffect(() => {
    // Get today's date in YYYY-MM-DD format
    const today = new Date();
    today.setDate(today.getDate() + 1);
    const toDateFormatted = today.toISOString().split("T")[0]; // Today's date as YYYY-MM-DD

    // Get the date 7 days ago
    const fromDateFormatted = new Date(today);
    fromDateFormatted.setDate(today.getDate() - 5); // Subtract 7 days
    const fromDateStr = fromDateFormatted.toISOString().split("T")[0]; // 7 days ago in YYYY-MM-DD

    // Set the state with the default values (7 days ago to today)
    setFromDate(fromDateStr);
    setToDate(toDateFormatted);
    getOrdersChange(fromDateStr, toDateFormatted, activeTab);
  }, []);

  const handleFromDateChange = (e) => {
    setFromDate(e.target.value);
    setOrders([]);
    setLoading(true);
    getOrdersChange(e.target.value, toDate, activeTabRef.current);
  };

  const handleToDateChange = (e) => {
    setToDate(e.target.value);
    setOrders([]);
    setLoading(true);
    getOrdersChange(fromDate, e.target.value, activeTabRef.current);
  };

  const getOrdersChange = async () => {
    console.log("called");

    try {
      const response = await axios.get(
        `${API_URL}shypvdriverapp/geocoding/invalid`
      );

      console.log(response.data); // Log or handle your geocoding data here
      // You can store this in state or further process it depending on your needs
      setallOrders(response.data.data); // Or another appropriate state handler
      setOrders(response.data.data); // Adjust based on the response structure
    } catch (error) {
      console.error("Error fetching geocoding data:", error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  // Check if all individual checkboxes are selected to update the "Select All" checkbox

  const [selectedAWB, setSelectedAWB] = useState(null); // Track the selected AWB
  const [selectedID, setSelectedID] = useState(null); // Track the selected AWB

  const buttonStyle = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginRight: "10px",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
    float: "right",
  };

  const center = {
    lat: 25.276987,
    lng: 55.296249,
  };

  const [msg, setMsg] = useState("");

  const handleViewReassign = async (awb, jobid) => {
    setMsg("");
    setSelectedAWB(awb);
    setSelectedID(jobid);

    // setImages(fetchedImages);
    $(".nalier.middle-center2.fade").css("display", "block");
    $(".nalier.middle-center2.fade").addClass("in");
  };

  const [shipmentDetails, setShipmentDetails] = useState([]);

  console.log("shipmentDetails", shipmentDetails);
  // Function to simulate image fetching (replace with actual API call)

  const [filteredOrders, setFilteredOrders] = useState([]);

  const exportData = filteredOrders.length > 0 ? filteredOrders : orders;
  const [partners, setPartners] = useState([]);
  useEffect(() => {
    const fetchPartners = async () => {
      const baseApiUrl = getApiBaseUrl();
      try {
        const response = await axios.get(
          `${baseApiUrl}/v1.0/partner/retrieve_list?page=0`
        );
        setPartners(response.data.data);
      } catch (err) {
        setError(err.message || "Error fetching data");
      } finally {
        // setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  const [selectedPartner, setSelectedPartner] = useState("0");

  const handleSelectChange = (e) => {
    const partnerId = e.target.value;

    if (partnerId === "0") {
      setSelectedPartner("0");
      setOrders(allOrders); // Show all
      return;
    }

    const partner = partners.find((p) => String(p.pid) === partnerId);
    setSelectedPartner(partner.pid);

    if (partner) {
      const filtered = allOrders.filter((order) =>
        order.awb?.includes(`UB${String(partner.pid).padStart(2, "0")}-`)
      );
      setOrders(filtered);
    } else {
      setOrders(allOrders); // Fallback
    }
  };

  useEffect(() => {
    $(".btn-demo.add2").on("click", function () {
      $(".nalier.right.fadeNalier").css("display", "block");
      $(".nalier.right.fadeNalier").addClass("in");
      // $('.nalier.right.fadeNalier input, .nalier.right.fadeNalier select').val('');
    });
  });

  console.log("partners:", partners);

  const [address, setAddress] = useState("");
  const [markerPosition, setMarkerPosition] = useState(null);
  const searchBoxRef = useRef(null);
  const mapRef = useRef(null);

  const [map, setMap] = useState(null);

  // function addressUpdate() {
  //     console.log('address is', map)
  // }

  const containerStyle = {
    width: "100%",
    height: "250px",
  };

  const addressUpdate = async () => {
    setMsg("processing...");
    // Submit logic here
    console.log("markerPosition", markerPosition);

    // alert("Submitted: " + address);
    // alert("Submitted: " + markerPosition.lat + markerPosition.lng);

    try {
      const response = await axios.post(
        `${API_URL}shypvdriverapp/geocoding/update/${selectedID}`,
        {
          formattedAddress: address,
          lat: markerPosition.lat,
          lng: markerPosition.lng,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        setMsg("Address updated successfully");
        setTimeout(() => {
          window.location.reload();
        }, 2000); // 2000ms = 2 seconds
      }

      console.log(" Success:", response.data);
    } catch (error) {
      console.error(" Error updating geocoding:", error);
      setMsg("Failed to update address");
    }
  };

  return (
    <div className="wrapper-holder">
      <div className="main-panel ps-container">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header card-header-primary"></div>
                  <div className="card-body">
                    <div className="row">
                      <div id="datepicker" style={{ marginRight: "-22%" }}>
                        <select
                          onChange={handleSelectChange}
                          value={selectedPartner}
                          style={{ marginRight: "10px", width: "200px" }}
                        >
                          <option value="" disabled>
                            -- Select a partner --
                          </option>
                          <option value="0">All</option>
                          {partners &&
                            [...partners]
                              .sort((a, b) => a.pname.localeCompare(b.pname))
                              .map((partner) => (
                                <option key={partner.pid} value={partner.pid}>
                                  {String(partner.pid).padStart(2, "0")} -{" "}
                                  {partner.pname}
                                </option>
                              ))}
                        </select>

                        <label htmlFor="fromDate">From Date: </label>
                        <input
                          type="date"
                          id="fromDate"
                          value={fromDate}
                          onChange={handleFromDateChange}
                        />

                        {/* To Date Picker */}
                        <label htmlFor="toDate">To Date: </label>
                        <input
                          type="date"
                          id="toDate"
                          value={toDate}
                          onChange={handleToDateChange}
                        />

                        {/* <CSVLink data={flattenOrderData(exportData)} filename={`${activeTab}.csv`} style={{ marginLeft: '10px' }}><i className='fa fa-download'></i></CSVLink> */}

                        {/* <button type="button" className="btn-demo add2" style={{ background: '#00a6f8', border: '#00a6f8', color: '#fff', marginLeft: '3%' }} data-toggle="modal" data-target="#myModal2"><i className="fa fa-plus" aria-hidden="true"></i> Filter</button> */}
                      </div>
                    </div>

                    {/* Main Tab Content */}
                    <div className="tab-content">
                      {activeTab === "ALL" && (
                        <div>
                          <div
                            className="dispatchbtn"
                            style={{ width: "24%" }}
                          ></div>

                          <DataTableExtensions {...tableData}>
                            <DataTable
                              columns={columns}
                              data={orders}
                              noHeader
                              pagination
                              highlightOnHover
                              dense
                              selectableRows // Enable row selection
                              defaultSortField="jobId"
                              defaultSortAsc={true}
                              searchable={orders.length > 0}
                              customStyles={{
                                // Apply styles to header and body cells for the "Phone" column
                                header: {
                                  style: {
                                    width: "150px", // Apply width to header
                                    textAlign: "left", // Ensure header text aligns with the content
                                  },
                                },
                                cells: {
                                  style: {
                                    width: "150px", // Apply width to the body cells
                                    textAlign: "left", // Ensure body cell text aligns with the header
                                  },
                                },
                              }}
                              noDataComponent={
                                loading ? "Loading..." : "No records to display" // Conditionally render based on loading
                              }
                            />
                          </DataTableExtensions>

                          {/* Display error message */}
                          {error && <p style={{ color: "red" }}>{error}</p>}

                          {/* Display the fetched data in a table */}

                          <div className="sub-tab-content"></div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* reassignment */}

          <div
            className="nalier middle-center2 fade"
            id="myModal3"
            role="dialog"
            aria-labelledby="myModalLabel"
            style={{ display: "none" }}
          >
            <div
              className="nalier-dialog"
              style={{ height: "auto" }}
              role="document"
            >
              <div className="nalier-content">
                <div className="nalier-header">
                  <button
                    type="button"
                    className="close h-close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 className="nalier-title" id="myModalLabel">
                    Update Address - {selectedAWB}
                  </h4>
                </div>
                <div className="nalier-body">
                  <div className="modal-gap">&nbsp;</div>

                  <div
                    className="row"
                    style={{
                      textAlign: "center",
                      padding: "15px",
                      margin: "15px",
                    }}
                  >
                    {isLoaded && (
                      <div
                        className="form-group"
                        style={{ marginBottom: "20px" }}
                      >
                        <Autocomplete
                          onLoad={(autoC) => (autocompleteRef.current = autoC)}
                          onPlaceChanged={() => {
                            const place = autocompleteRef.current.getPlace();
                            console.log("Selected place:", place); // ✅ Debug log

                            if (!place || !place.place_id) {
                              alert(
                                "Please select a valid address from the suggestions."
                              );
                              return;
                            }

                            if (place.geometry) {
                              const lat = place.geometry.location.lat();
                              const lng = place.geometry.location.lng();
                              setAddress(place.formatted_address || place.name);
                              setMarkerPosition({ lat, lng });

                              if (map) {
                                map.panTo({ lat, lng });
                                map.setZoom(15);
                              }
                            }
                          }}
                        >
                          <input
                            type="text"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            placeholder="Enter address"
                            style={{ padding: "10px", marginBottom: "3%" }}
                          />
                        </Autocomplete>

                        <GoogleMap
                          mapContainerStyle={containerStyle}
                          center={markerPosition || center}
                          zoom={15}
                          onLoad={(mapInstance) => setMap(mapInstance)}
                        >
                          {markerPosition && (
                            <Marker position={markerPosition} />
                          )}
                        </GoogleMap>

                        <a
                          onClick={addressUpdate}
                          style={buttonStyle}
                          className="btn-demo add"
                        >
                          Submit
                        </a>
                      </div>
                    )}

                    <p>{msg}</p>
                  </div>
                  <div className="row">
                    <div className="col-md-6"></div>
                    <div className="col-md-5"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* reassignment */}
        </div>
      </div>

      {/* End Modal Right */}
    </div>
  );
}
